// src/app/shared/pipes/filter.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }

    // If filter is a string, assume we're doing a simple string match
    if (typeof filter === 'string') {
      return items.filter(item => JSON.stringify(item).toLowerCase().includes(filter.toLowerCase()));
    }

    // If filter is an object, filter by matching properties
    return items.filter(item => {
      const notMatchingField = Object.keys(filter)
        .find(key => {
          if (filter[key] !== null && filter[key] !== undefined) {
            const val = this.getProperty(item, key);
            if (val === null || val === undefined) {
              return true;
            }

            // For string comparison
            if (typeof val === 'string') {
              return !val.toLowerCase().includes((filter[key] + '').toLowerCase());
            }

            // For exact match (numbers, booleans, etc)
            return val !== filter[key];
          }
          return false;
        });

      return !notMatchingField; // true if all fields match, false if at least one doesn't match
    });
  }

  // Helper method to get nested properties like "user.name"
  private getProperty(item: any, path: string): any {
    return path.split('.').reduce((o, i) => o ? o[i] : null, item);
  }
}
